import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import GridUnit from '../components/GridUnit'
import Section from '../components/Section'
import BackArrow from '../components/BackArrow'
import Button from '../components/Button'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faStroopwafel,
  faSearchPlus,
  faLightbulb,
  faPencilAlt,
  faChartBar,
  faBullseye,
  faNewspaper,
  faTrophy,
  faComments,
} from '@fortawesome/free-solid-svg-icons'
library.add([
  faSearchPlus,
  faLightbulb,
  faPencilAlt,
  faChartBar,
  faBullseye,
  faNewspaper,
  faTrophy,
  faComments,
])

import './style.scss'

import grayling from '../assets/images/ui/grayling.png'
import fleishman from '../assets/images/ui/fleishman.png'

import ifat from '../assets/images/ui/ifat.png'
import amiram from '../assets/images/ui/amiram.png'

class AboutPage extends Component {
  constructor(props) {
    super(props)
    this.toggleIfat = this.toggleIfat.bind(this)
    this.toggleAmiram = this.toggleAmiram.bind(this)
  }
  componentWillMount() {
    this.setState({
      ifatMore: false,
      amiramMore: false,
    })
  }
  toggleAmiram() {
    this.setState({
      amiramMore: !this.props.amiramMore,
    })
  }
  toggleIfat() {
    this.setState({
      ifatMore: !this.props.ifatMore,
    })
  }
  render() {
    return (
      <div className="index">
        <div className="main">
          <Helmet title="Fleisher Communications - About" />
          <BackArrow />

          {/* Who we are */}
          <Section title="Who we are">
            <div className="row about_header">
              <div className="col-xs-12 col-sm-8 col-md-6">
                <h3>
                  <b>
                    Established in 1988 by Amiram and Ifat Fleisher,{' '}
                    <span className="orange">Fleisher Communications</span> is
                    one of Israel’s leading public relations firms.
                  </b>
                </h3>
                <p>
                  Our core objective here in Fleisher Communications is to
                  provide high quality PR and strategic consulting services to
                  all of our clientele, in order to place them at the forefront
                  of the Israeli market. We in Fleisher Communications offer
                  unique, tailor made solutions in PR and communications to
                  dozens of Israeli firms and international brands. Our firm
                  deals predominately with PR for business and financial
                  companies, specializing in international brands. We also work
                  in such diverse fields as finance, high-tech, energy, media
                  networks, aviation and government.
                </p>
              </div>
            </div>
          </Section>
          <Section title="Affiliations">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6">
                <img className="fullwidth" src={grayling} />
                <p className="center">
                  Grayling is a leading global communications network founded in
                  1981 to deliver data-driven strategies for Public Relations,
                  Government Affairs, Investor Relations and Event Management.
                </p>
                <p className="center">
                  <a href="https://www.grayling.com/" target="_blank">
                    grayling.com
                  </a>
                </p>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6">
                <img className="fullwidth" src={fleishman} />
                <p className="center">
                  FleishmanHillard is a leading global communications network
                  founded in 1946 with more than 111 offices in 29 countries
                  across the Americas, Asia Pacific, Europe, Middle East, and
                  Africa.
                </p>
                <p className="center">
                  <a href="http://fleishmanhillard.com" target="_blank">
                    fleishmanhillard.com
                  </a>
                </p>
              </div>
            </div>
          </Section>

          {/* Our way of working */}
          <Section title="Process">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6">
                <p>
                  In today’s globalized world, the flow of information is
                  continues. Action and reaction happen almost simultaneously
                  and media occurrences happen in real-time. In this dynamic
                  reality, our model of small, specialized teams, enables us to
                  serve our clientele base 24/7.
                </p>
              </div>
            </div>
            <br />
            <div className="row center">
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon
                    className="process_icon"
                    icon="search-plus"
                  />
                </h5>
                <p>01. Research</p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="process_icon" icon="lightbulb" />
                </h5>
                <p>02. Development</p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="process_icon" icon="pencil-alt" />
                </h5>
                <p>03. Planning</p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="process_icon" icon="bullseye" />
                </h5>
                <p>04. Execution</p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="process_icon" icon="newspaper" />
                </h5>
                <p>05. Monitoring</p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="process_icon" icon="chart-bar" />
                </h5>
                <p>06. Analysis</p>
              </div>
            </div>
          </Section>

          {/* Recognition */}
          <Section title="Recognition">
            <p>
              Our team’s recent accomplishments in the different fields of PR,
              are a reflection of our constant strive for ingenuity and
              creativity
            </p>
            <br />
            <div className="row center">
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="award_icon" icon="trophy" />
                </h5>
                <p>Best Short Term Campaign</p>
                <p style={{ fontSize: '10pt' }}>
                  Sector – Infrastructure
                  <br />
                  Client – IDE Technologies
                  <br />
                  Award – ISPRA
                </p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="award_icon" icon="trophy" />
                </h5>
                <p>Best Campaign</p>
                <p style={{ fontSize: '10pt' }}>
                  Sector – Cellular
                  <br />
                  Client – Pelephone Comm.
                  <br />
                  Award – ISPRA
                </p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="award_icon" icon="trophy" />
                </h5>
                <p>Best Campaign</p>
                <p style={{ fontSize: '10pt' }}>
                  Sector – Banking & Investment
                  <br />
                  Client – Dexia Bank
                  <br />
                  Award – ISPRA
                </p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="award_icon" icon="trophy" />
                </h5>
                <p>Best Campaign</p>
                <p style={{ fontSize: '10pt' }}>
                  Sector – Banking & Investment
                  <br />
                  Client – Psagot
                  <br />
                  Award – ISPRA
                </p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="award_icon" icon="trophy" />
                </h5>
                <p>Best Campaign</p>
                <p style={{ fontSize: '10pt' }}>
                  Sector – Insurance
                  <br />
                  Client – Harel Insurance
                  <br />
                  Award – ISPRA
                </p>
              </div>
              <div className="col-xs-4 col-sm-2 col-md-2">
                <h5>
                  <FontAwesomeIcon className="award_icon" icon="trophy" />
                </h5>
                <p>Best Campaign</p>
                <p style={{ fontSize: '10pt' }}>
                  Sector – Cellular
                  <br />
                  Client – Pelephone Comm.
                  <br />
                  Award – ISPRA
                </p>
              </div>
            </div>
          </Section>

          {/* Leadership */}
          <Section title="Leadership">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6">
                <img
                  style={{ width: '100px', margin: 'auto', display: 'block' }}
                  src={amiram}
                />
                <h5 className="center">
                  <span className="bold">Amiram Fleisher</span>
                  <br />
                  Managing partner & CEO
                  <br />
                  <a
                    style={{ fontSize: '10pt' }}
                    href="mailto:amiram@fleisher-pr.com"
                  >
                    amiram@fleisher-pr.com
                  </a>
                </h5>
                <p>
                  Amiram is the driving force behind Fleisher Communications. He
                  leads the firm’s contacts, both with the clientele and the
                  media. Over 35 years of intensive activity in the Israeli
                  media market has made Amiram an expert in his field, with a
                  deep acquaintance and understanding of all the different media
                  sectors.
                </p>
                <div
                  style={{ display: this.state.amiramMore ? 'block' : 'none' }}
                >
                  <p>
                    In recent years, Amiram has been serving as a special
                    economic media consultant for the Israeli Prime Minister,
                    helping the ongoing building of the PM’s office activities
                    with the media.
                  </p>
                  <p>
                    Before founding Fleisher Communication, Amiram was the
                    spokesperson for the Israeli Ministry of Commerce and
                    Industry, where he was charged with the complex mission of
                    publicising the Economic Emergency Plan.
                  </p>
                  <p>
                    Prior this appointment, Amiram has worked as a leading
                    economical correspondent for Maariv Daily, where he was in
                    charge of economy and finance.
                  </p>
                  <p>
                    Amiram has also served as the economic correspondent for the
                    IDF’s radio. Moreover, Amiram is a Colonel in reserve and
                    serves actively in the IDF’s Spokesperson. Amiram has
                    academical education from both the Tel Aviv University and
                    B.Y.U
                  </p>
                </div>
                <button
                  style={{ display: this.state.amiramMore ? 'none' : 'block' }}
                  className="read_more_btn"
                  onClick={this.toggleAmiram}
                >
                  Read more
                </button>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6">
                <img
                  style={{ width: '100px', margin: 'auto', display: 'block' }}
                  src={ifat}
                />
                <h5 className="center">
                  <span className="bold">Ifat Fleisher</span>
                  <br />
                  Managing partner & COO
                  <br />
                  <a
                    style={{ fontSize: '10pt' }}
                    href="mailto:ifat@fleisher-pr.com"
                  >
                    ifat@fleisher-pr.com
                  </a>
                </h5>
                <p>
                  Ifat serves as the company’s business manager. She guides the
                  staff and is responsible for all of the office’s major
                  activities. She is in charge of planning, consolidation and
                  integration of the office’s business development.
                </p>
                <div
                  style={{ display: this.state.ifatMore ? 'block' : 'none' }}
                >
                  <p>
                    Ifat received a B.A. from Bar Ilan University and an M.A. in
                    communications, specialising in public relations, from Clark
                    University in Massachusetts, USA.
                  </p>
                  <p>
                    She has also completed a special training from Bar Ilan
                    University focusing on both global and Israeli financial
                    markets.
                  </p>
                </div>
                <button
                  style={{ display: this.state.ifatMore ? 'none' : 'block' }}
                  className="read_more_btn"
                  onClick={this.toggleIfat}
                >
                  Read more
                </button>
              </div>
            </div>
          </Section>

          <br />
          <div className="row">
            <div className="col-xs-12 col-sm-3 col-md-4" />
            <Button
              link="/services"
              buttonStyle="dark_btn"
              text="Learn more"
              mobileWidth={'6'}
              smallWidth={'3'}
              mediumWidth={'2'}
            />
            <Button
              link="/contact"
              buttonStyle="dark_btn"
              text="Get in touch"
              mobileWidth={'6'}
              smallWidth={'3'}
              mediumWidth={'2'}
            />
          </div>
          <br />
        </div>
      </div>
    )
  }
}

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js